var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _path28, _path29, _path30, _g3, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroimagev2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 902,
    height: 616,
    viewBox: "0 0 902 616",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_408_60",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 902,
    height: 618
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M659.559 117.154C912.693 173.569 972.684 423.201 814.71 617.461H14.71C5.01825 591.351 -9.21252 527.193 8.23248 495.861C30.0388 456.696 59.8407 430.377 51.3605 351.733C3.38666 99.5084 153.608 12.7183 299.468 1.75206C445.327 -9.21422 536.494 31.5428 659.559 117.154Z",
    fill: "url(#paint0_linear_408_60)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_408_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M659.559 117.154C912.693 173.569 972.684 423.201 814.71 617.461H14.71C5.01825 591.351 -9.21252 527.193 8.23248 495.861C30.0388 456.696 59.8407 430.377 51.3605 351.733C3.38666 99.5084 153.608 12.7183 299.468 1.75206C445.327 -9.21422 536.494 31.5428 659.559 117.154Z",
    fill: "url(#paint1_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.126 457.384H-165.641H-197.964L-209.79 637.055L-106.512 642.714L550.21 617.249V484.264V470.588H523.799V440.878L482.409 437.577L485.563 497.468H444.173V519.632H426.828V506.899H407.513L402.783 457.384H358.239V375.329H318.426V420.601H307.783V382.403H270.729V445.594H258.115V432.39L174.94 429.561V463.043H151.683V375.329H71.268V489.451H42.4921V470.588H9.38007V437.577H-33.1926L-36.3461 497.468H-74.9767V519.632H-95.4747V506.899H-115.578L-119.126 457.384Z",
    fill: "url(#paint2_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.21 689.259L570.71 36.1465L922.71 54.4673L939.71 661.53L554.21 689.259Z",
    fill: "url(#paint3_linear_408_60)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 321.75,
    height: 176.214,
    rx: 5,
    transform: "matrix(-1 0 0 1 579.085 127.751)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.855 175.793C313.313 144.718 281.812 189.579 273.21 213.908H385.21V150.654C370.345 148.383 370.242 177.415 362.5 189.174C352.178 201.338 339.274 209.042 325.855 175.793Z",
    fill: "url(#paint4_linear_408_60)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 8.85093,
    rx: 4,
    transform: "matrix(-1 0 0 1 587.21 301.551)",
    fill: "#C1D1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.397,
    y: 155.108,
    width: 19.5,
    height: 9.65556,
    rx: 3,
    fill: "#4C0025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.397,
    y: 169.591,
    width: 26.8125,
    height: 3.21852,
    rx: 1,
    fill: "#4C0025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.397,
    y: 178.442,
    width: 53.625,
    height: 3.21852,
    rx: 1,
    fill: "#4C0025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.397,
    y: 187.293,
    width: 53.625,
    height: 3.21852,
    rx: 1,
    fill: "#4C0025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.397,
    y: 196.144,
    width: 53.625,
    height: 3.21852,
    rx: 1,
    fill: "#4C0025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.397,
    y: 204.995,
    width: 39,
    height: 3.21852,
    rx: 1,
    fill: "#4C0025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.585 281.435V269.014C273.585 266.098 275.949 263.733 278.866 263.733V263.733C281.783 263.733 284.147 266.098 284.147 269.014V281.435H273.585Z",
    fill: "url(#paint5_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.147 281.435V251.312C310.147 248.396 312.512 246.031 315.429 246.031V246.031C318.345 246.031 320.71 248.396 320.71 251.312V281.435H310.147Z",
    fill: "url(#paint6_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.835 281.435V272.631C328.835 269.939 331.018 267.756 333.71 267.756V267.756C336.402 267.756 338.585 269.939 338.585 272.631V281.435H328.835Z",
    fill: "#4C0025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.71 281.435V263.78C346.71 261.088 348.893 258.905 351.585 258.905V258.905C354.277 258.905 356.46 261.088 356.46 263.78V281.435H346.71Z",
    fill: "#4C0025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.272 281.435V261.366C292.272 258.674 294.455 256.491 297.147 256.491V256.491C299.84 256.491 302.022 258.674 302.022 261.366V281.435H292.272Z",
    fill: "url(#paint7_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.941 464.316H245.182H212.688L200.8 643.987L304.622 649.646L964.8 624.181V491.196V477.52H938.25V447.811L896.643 444.51L899.813 504.4H858.205V526.564H840.769V513.832H821.352L816.597 464.316H771.819V382.261H731.796V427.533H721.097V389.335H683.848V452.526H671.168V439.322L587.555 436.493V469.975H564.176V382.261H483.338V496.383H454.41V477.52H421.124V444.51H378.327L375.157 504.4H336.323V526.564H315.717V513.832H295.508L291.941 464.316Z",
    fill: "url(#paint8_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.21 -20.7675C538.21 -22.4244 536.867 -23.7675 535.21 -23.7675V-23.7675C533.553 -23.7675 532.21 -22.4244 532.21 -20.7675V127.751H538.21V-20.7675Z",
    fill: "#C1D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.21 -20.7675C304.21 -22.4244 302.867 -23.7675 301.21 -23.7675V-23.7675C299.553 -23.7675 298.21 -22.4244 298.21 -20.7675V127.751H304.21V-20.7675Z",
    fill: "#C1D1FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.771 605.169C258.781 606.106 245.684 601.001 241.135 598.332C235.027 597.876 222.487 597.292 221.189 598.603C219.566 600.243 219.899 610.804 221.389 616.009C222.879 621.214 236.747 618.505 238.209 618.391C239.378 618.3 239.938 616.426 240.071 615.501C241.585 615.569 247.835 616.104 260.723 617.695C281.928 619.734 279.312 605.374 274.771 605.169Z",
    fill: "#E6EDFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.165 600.51L240.478 599.74C241.669 599.684 242.544 598.607 242.354 597.43L209.89 395.98L169.872 402.566L178.718 439.043L200.536 516.921L221.107 598.242C221.458 599.628 222.737 600.577 224.165 600.51Z",
    fill: "url(#paint9_linear_408_60)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.21 596.664C131.515 600.76 143.768 598.405 150.21 598.15C179.594 493.295 180.498 423.883 176.319 400.875L136.352 403.435L141.611 500.959C138.42 531.137 130.904 592.569 131.21 596.664Z",
    fill: "url(#paint10_linear_408_60)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.701 605.058C167.69 605.51 154.757 600.012 150.292 597.206C144.202 596.566 131.686 595.602 130.348 596.874C128.675 598.463 128.682 609.03 130.01 614.277C131.339 619.525 145.284 617.237 146.749 617.167C147.92 617.111 148.537 615.256 148.7 614.335C150.211 614.449 156.441 615.172 169.274 617.153C190.405 619.833 188.234 605.401 183.701 605.058Z",
    fill: "#E6EDFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.123 302.628C125.951 297.67 139.397 290.388 145.766 287.367L174.543 301.179L176.819 285.38L201.208 289.31C203.692 289.71 205.497 291.891 205.423 294.403L204.758 317.103C206.651 341.84 210.452 392.749 210.509 398.485C202.037 404.629 157.738 405.851 136.648 405.693L131.048 347.551C127.227 334.642 120.294 307.586 123.123 302.628Z",
    fill: "url(#paint11_linear_408_60)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.832 329.541C142.884 381.623 160.356 401.494 168.457 405.045L128.912 406.402L122.009 331.706C122.72 331.231 127.08 330.134 138.832 329.541Z",
    fill: "url(#paint12_linear_408_60)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.595 437.643L152.914 427.72L141.172 433.251C142.065 433.423 144.396 436.167 146.584 445.763C149.317 457.758 150.31 456.482 156.805 457.369C164.9 457.475 161.804 451.557 159.611 447.819C158.637 445.552 157.046 441.086 158.474 441.361C164.929 442.828 162.578 439.493 160.595 437.643Z",
    fill: "url(#paint13_linear_408_60)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.49 374.059C109.568 365.935 118.117 324.138 122.701 303.831C148.667 311.688 138.089 372.487 138.867 378.417C139.646 384.347 155.32 424.252 155.617 426.511C155.913 428.769 144.916 433.343 138.965 434.396C133.014 435.449 116.142 384.213 112.49 374.059Z",
    fill: "url(#paint14_linear_408_60)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.668 283.736C154.088 282.735 152.913 273.335 152.022 268.759L174.607 270.734L176.534 285.417L175.188 301.67L175.014 302.554L163.626 293.108L146.262 286.729C147.696 285.874 150.785 284.079 151.668 283.736Z",
    fill: "#FFB27F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.233 303.942C168.828 298.297 172.04 299.778 173.081 301.08C177.098 298.553 155.267 286.431 153.656 285.203C152.367 284.22 152.492 282.96 152.715 282.453C150.459 282.935 145.792 284.492 145.176 286.869C144.406 289.839 161.282 305.757 164.233 303.942Z",
    fill: "url(#paint15_linear_408_60)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.559 265.416L177.472 290.199C164.689 285.101 158.454 273.784 156.935 268.762L173.559 265.416Z",
    fill: "#F3A36A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.4 274.731C193.619 299.298 191.45 262.153 186.27 241.093L165.385 236.603L149.4 249.571L148.686 264.02L154.138 270.21L161.4 274.731Z",
    fill: "#FFB27F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M153.002 272.079L154.875 268.679C154.218 268.094 152.682 266.55 151.79 265.056C149.562 258.681 153.152 259.234 155.226 260.307C156.849 261.63 160.302 264.076 161.125 263.281C162.155 262.287 158.599 257.289 161.413 256.639C164.228 255.99 164.502 253.658 164.416 250.797C164.331 247.937 163.427 245.469 166.315 245.384C194.74 245.459 186.067 236.812 185.844 235.118C184.57 229.826 159.622 218.68 145.618 235.701C134.415 249.318 145.873 265.626 153.002 272.079Z",
    fill: "#4C0025"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M178.561 298.652L181.349 300.016C185.811 302.198 183.408 291.711 181.907 286.161L176.552 285.128C175.265 289.313 174.208 298.178 174.643 299.73C175.079 301.282 177.412 299.47 178.561 298.652Z",
    fill: "url(#paint16_linear_408_60)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M267.525 364.443C264.847 365.247 259.062 364.766 256.504 364.425C253.714 367.465 248.961 373.666 252.273 374.158C256.413 374.774 264.65 384.625 274.655 385.635C293.944 384.588 280.461 376.848 277.957 375.447C275.454 374.046 268.514 369.771 270.436 368.949C280.045 364.841 270.872 363.438 267.525 364.443Z",
    fill: "url(#paint17_linear_408_60)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M220.271 337.725L206.463 294.624C205.661 292.123 201.97 292.691 201.971 295.315L201.975 310.913L206.275 348.19L209.786 354.669C221.971 361.187 247.236 374.742 250.819 376.822C254.104 376.63 257.464 367.4 258.734 362.808L220.271 337.725Z",
    fill: "url(#paint18_linear_408_60)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M203.631 318.723L210.776 354.533L207.085 348.147L203.631 318.723Z",
    fill: "url(#paint19_linear_408_60)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M611.21 433.262C613.21 437.224 618.978 430.545 622.21 430.787C623.326 415.873 619.715 408.893 615.532 405.22C610.302 400.627 604.116 411.305 606.948 416.422C609.781 421.539 606.296 423.529 611.21 433.262Z",
    fill: "#F7B39D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M604.611 417.074C604.296 420.544 612.573 421.304 616.751 421.25L647.409 352.588L655.765 308.516L639.577 306.575C632.041 315.493 616.112 333.76 614.664 336.068C612.71 339.183 605.004 412.737 604.611 417.074Z",
    fill: "#F2FDFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M626.688 562.893C625.504 570.508 626.267 589.875 626.688 597.655C627.742 598.784 648.368 602.235 650.21 600.13C652.052 598.026 649.048 575.305 648.801 570.508C648.602 566.669 650.711 548.382 651.79 539.719C648.584 526.462 646.188 495.143 645.055 488.308C643.922 481.473 638.31 439 637.795 417.07L613.658 416.123C618.595 452.011 616.434 501.637 616.248 510.684C616.016 521.992 628.168 553.375 626.688 562.893Z",
    fill: "url(#paint20_linear_408_60)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M643.768 493.045C643.789 503.493 646.531 533.854 650.296 555.113C653.302 572.09 652.512 589.452 651.738 596.051C651.737 596.063 651.723 596.348 651.682 597.391C651.41 600.863 672.397 601.468 676.795 601.423C681.192 601.378 678.815 589.378 679.304 577.145C679.939 561.282 679.898 523.845 677.794 510.486C676.478 502.128 677.195 459.533 684.563 445.675C690.456 434.589 687.847 420.339 685.805 414.6L624.823 417.214L635.46 437.002C638.222 452.2 643.75 484.687 643.768 493.045Z",
    fill: "#3D8F7D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M639.132 312.216C624.021 347.144 645.04 322.025 657.438 305.099L657.221 310.532C635.726 342.423 635.297 395.28 637.769 417.722L635.355 417.627C613.673 419.04 608.549 415.632 608.698 413.752C610.621 393.151 614.986 349.923 616.225 340.918C617.465 331.912 631.931 314.546 638.891 307.201C639.02 307.641 638.892 309.421 639.132 312.216Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M609.473 609.821C614.613 608.803 623.074 601.286 626.663 597.654C635.258 597.048 652.309 597.136 651.749 602.338C651.19 607.539 651.644 615.973 651.941 619.539C639.495 619.341 613.073 618.711 606.957 617.775C599.312 616.604 603.049 611.092 609.473 609.821Z",
    fill: "#E6EDFB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M635.579 609.572C640.718 608.554 649.18 601.036 652.769 597.405C661.364 596.799 678.415 596.887 677.855 602.089C677.696 603.574 677.618 605.323 677.597 607.148C677.519 613.655 672.403 619.201 665.897 619.045C653.064 618.738 637.565 618.215 633.063 617.526C625.418 616.355 629.155 610.843 635.579 609.572Z",
    fill: "#E6EDFB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M639.399 344.003L657.92 304.03L667.23 296.56C670.542 297.996 678.42 302.527 683.429 309.166C688.438 315.805 687.11 363.649 685.82 386.742L686.346 406.568C686.718 408.252 687.442 412.14 687.358 414.226C667.575 425.29 645.103 423.015 636.339 420.495L634.102 377.531L639.399 344.003Z",
    fill: "#F2FDFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_408_60",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 623,
    y: 253,
    width: 42,
    height: 77
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M627.617 299.359C620.244 299.07 624.26 273.4 627.189 260.601L641.326 253.32L664.714 267.514L664.56 298.849C660.743 302.69 652.043 312.505 646.323 319.246C629.296 340.516 632.668 325.457 639.131 312.216L638.289 301.542C638.21 300.532 637.389 299.742 636.377 299.702L627.617 299.359Z",
    fill: "#F7B39D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_408_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.71 298.849C622.337 298.56 625.281 273.747 628.21 260.948L641.326 253.32L664.714 267.514L664.56 298.849C660.743 302.69 652.043 312.505 646.323 319.246C629.296 340.516 632.668 325.457 639.132 312.216L638.289 301.542C638.21 300.532 637.419 299.558 636.419 299.394C635.268 299.206 633.279 298.989 629.71 298.849Z",
    fill: "#F7B39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.21 298.58C644.41 299.372 637.877 299.57 634.71 299.57L638.71 312.939C641.21 307.823 646.01 297.787 645.21 298.58Z",
    fill: "#E89B81"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M628.029 260.676C629.935 261.224 632.045 261.671 634.123 262.03C639.492 262.957 644.083 267.682 646.765 272.422C648.314 275.162 649.999 277.477 650.485 278.894C650.862 279.991 650.217 284.439 649.229 289.68C647.555 298.565 653.608 307.177 662.617 307.927C667.057 308.296 671.789 308.65 676.044 308.884C684.22 309.334 691.534 304.809 692.121 296.641C692.597 290.03 691.82 283.015 690.694 279.165C689.766 275.998 689.132 273.092 688.549 269.815C687.049 261.384 684.93 252.487 678.205 247.188C665.227 236.961 647.223 240.193 634.81 245.338C629.817 247.407 625.961 251.901 625.521 257.287C625.389 258.902 626.471 260.229 628.029 260.676Z",
    fill: "#4C0025"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M692.404 394.102C701.464 332.428 688.305 311.598 682.445 313.399L671.083 322.748C669.475 326.312 666.058 334.086 665.251 336.666C664.445 339.246 667.476 361.638 669.092 372.511C660.468 373.841 642.169 376.373 637.97 375.86C632.061 369.752 629.604 369.084 628.077 368.806C626.55 368.529 625.239 364.479 619.533 364.255C617.713 364.184 618.341 366.602 621.756 369.13C625.171 371.658 624.091 371.181 622.293 372.198C611.261 371.069 614.614 375.525 617.669 377.894C617.965 379.646 618.885 383.774 620.192 386.263C621.825 389.374 641.567 388.634 644.47 389.174C650.95 390.38 684.637 395.973 692.404 394.102Z",
    fill: "#FFB37D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M692.338 394.099C701.398 332.425 688.239 311.595 682.38 313.397L671.017 322.745C669.409 326.309 665.992 334.083 665.186 336.663C664.379 339.244 667.41 361.635 669.027 372.508C663.465 373.366 653.879 374.724 646.647 375.443L644.405 389.172C650.884 390.377 684.571 395.971 692.338 394.099Z",
    fill: "#3D8F7D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 68.3317,
    rx: 8,
    transform: "matrix(1 0 0 -1 461.21 223.811)",
    fill: "url(#paint21_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.322289,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.032 165.103C509.251 165.103 520.777 176.091 520.777 189.645C520.777 203.199 509.251 214.187 495.032 214.187C480.814 214.187 469.287 203.199 469.287 189.645C469.287 176.091 480.814 165.103 495.032 165.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.032 165.103C509.251 165.103 520.777 176.091 520.777 189.645C520.777 189.645 503.497 189.645 494.856 189.645L495.032 165.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.369 190.367H537.436",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.369 183.389H543.494",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.369 176.171H533.902",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.369 169.194H548.542",
    stroke: "white",
    strokeWidth: 2
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.71 292.143C449.97 292.143 437.21 279.506 437.21 263.919C437.21 248.331 449.97 235.695 465.71 235.695C481.45 235.695 494.21 248.331 494.21 263.919C494.21 279.506 481.45 292.143 465.71 292.143ZM465.71 277.288C473.166 277.288 479.21 271.302 479.21 263.919C479.21 256.535 473.166 250.549 465.71 250.549C458.254 250.549 452.21 256.535 452.21 263.919C452.21 271.302 458.254 277.288 465.71 277.288Z",
    fill: "#E1E8FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.71 287.191C455.97 287.191 443.21 274.555 443.21 258.967C443.21 243.379 455.97 230.743 471.71 230.743C487.45 230.743 500.21 243.379 500.21 258.967C500.21 274.555 487.45 287.191 471.71 287.191ZM471.71 272.336C479.166 272.336 485.21 266.351 485.21 258.967C485.21 251.584 479.166 245.598 471.71 245.598C464.254 245.598 458.21 251.584 458.21 258.967C458.21 266.351 464.254 272.336 471.71 272.336Z",
    fill: "url(#paint22_linear_408_60)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M471.71 238.171C460.112 238.171 450.71 247.482 450.71 258.967C450.71 270.453 460.112 279.764 471.71 279.764V279.764C483.308 279.764 492.71 270.453 492.71 258.967",
    stroke: "white",
    strokeWidth: 15
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.71 292.143C520.97 292.143 508.21 279.506 508.21 263.919C508.21 248.331 520.97 235.695 536.71 235.695C552.45 235.695 565.21 248.331 565.21 263.919C565.21 279.506 552.45 292.143 536.71 292.143ZM536.71 277.288C544.166 277.288 550.21 271.302 550.21 263.919C550.21 256.535 544.166 250.549 536.71 250.549C529.254 250.549 523.21 256.535 523.21 263.919C523.21 271.302 529.254 277.288 536.71 277.288Z",
    fill: "#E1E8FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.71 287.191C526.97 287.191 514.21 274.555 514.21 258.967C514.21 243.379 526.97 230.743 542.71 230.743C558.45 230.743 571.21 243.379 571.21 258.967C571.21 274.555 558.45 287.191 542.71 287.191ZM542.71 272.336C550.166 272.336 556.21 266.351 556.21 258.967C556.21 251.584 550.166 245.598 542.71 245.598C535.254 245.598 529.21 251.584 529.21 258.967C529.21 266.351 535.254 272.336 542.71 272.336Z",
    fill: "url(#paint23_linear_408_60)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M542.71 238.171C531.112 238.171 521.71 247.482 521.71 258.967C521.71 270.453 531.112 279.764 542.71 279.764V279.764C554.308 279.764 563.71 270.453 563.71 258.967",
    stroke: "white",
    strokeWidth: 15
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M543.71 236.19C532.112 236.19 522.71 245.501 522.71 256.987C522.71 268.472 532.112 277.783 543.71 277.783V277.783C555.308 277.783 564.71 268.472 564.71 256.987",
    stroke: "white",
    strokeWidth: 15
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.5 290.399C375.76 290.399 363 277.763 363 262.176C363 246.588 375.76 233.952 391.5 233.952C407.24 233.952 420 246.588 420 262.176C420 277.763 407.24 290.399 391.5 290.399ZM391.5 275.545C398.956 275.545 405 269.559 405 262.176C405 254.792 398.956 248.806 391.5 248.806C384.044 248.806 378 254.792 378 262.176C378 269.559 384.044 275.545 391.5 275.545Z",
    fill: "#E1E8FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.5 285.448C381.76 285.448 369 272.812 369 257.224C369 241.636 381.76 229 397.5 229C413.24 229 426 241.636 426 257.224C426 272.812 413.24 285.448 397.5 285.448ZM397.5 270.593C404.956 270.593 411 264.608 411 257.224C411 249.84 404.956 243.855 397.5 243.855C390.044 243.855 384 249.84 384 257.224C384 264.608 390.044 270.593 397.5 270.593Z",
    fill: "url(#paint24_linear_408_60)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M397.5 236.427C385.902 236.427 376.5 245.738 376.5 257.224C376.5 268.71 385.902 278.021 397.5 278.021V278.021C409.098 278.021 418.5 268.71 418.5 257.224",
    stroke: "white",
    strokeWidth: 15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_408_60",
    x1: 450.211,
    y1: 0,
    x2: 450.211,
    y2: 619.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_408_60",
    x1: 450.9,
    y1: 0,
    x2: 450.9,
    y2: 617.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#486757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_408_60",
    x1: 170.21,
    y1: 375.329,
    x2: 170.21,
    y2: 642.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7FFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_408_60",
    x1: 746.96,
    y1: 36.1465,
    x2: 746.96,
    y2: 689.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#486757",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_408_60",
    x1: 318.987,
    y1: 184.213,
    x2: 325.465,
    y2: 214.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C0025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C012D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_408_60",
    x1: 273.585,
    y1: 272.584,
    x2: 284.147,
    y2: 272.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C0025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61002F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_408_60",
    x1: 310.147,
    y1: 263.733,
    x2: 320.71,
    y2: 263.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C0025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61002F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_408_60",
    x1: 292.272,
    y1: 268.963,
    x2: 302.022,
    y2: 268.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C0025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61002F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_408_60",
    x1: 582.8,
    y1: 382.261,
    x2: 582.8,
    y2: 649.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7FFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_408_60",
    x1: 192.785,
    y1: 398.182,
    x2: 219.103,
    y2: 602.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#486757",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_408_60",
    x1: 141.214,
    y1: 402.809,
    x2: 166.091,
    y2: 596.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#486757",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_408_60",
    x1: 162.136,
    y1: 285.26,
    x2: 177.549,
    y2: 405.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_408_60",
    x1: 138.505,
    y1: 335.754,
    x2: 158.664,
    y2: 420.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68C9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_408_60",
    x1: 150.757,
    y1: 427.997,
    x2: 154.592,
    y2: 457.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_408_60",
    x1: 121.335,
    y1: 304.007,
    x2: 138.13,
    y2: 434.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_408_60",
    x1: 157.804,
    y1: 281.798,
    x2: 160.722,
    y2: 304.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_408_60",
    x1: 177.575,
    y1: 284.996,
    x2: 179.594,
    y2: 300.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_408_60",
    x1: 266.136,
    y1: 363.186,
    x2: 269.136,
    y2: 386.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5935B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_408_60",
    x1: 222.33,
    y1: 277.971,
    x2: 235.31,
    y2: 378.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_408_60",
    x1: 203.415,
    y1: 321.116,
    x2: 218.951,
    y2: 351.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68C9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_408_60",
    x1: 635.805,
    y1: 416.992,
    x2: 628.621,
    y2: 600.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B09D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_408_60",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 68.3317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C0025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C0025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_408_60",
    x1: 443.21,
    y1: 230.743,
    x2: 443.21,
    y2: 287.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C0025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C0025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_408_60",
    x1: 514.21,
    y1: 230.743,
    x2: 514.21,
    y2: 287.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C0025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C0025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_408_60",
    x1: 369,
    y1: 229,
    x2: 369,
    y2: 285.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C0025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C0025"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 68.3317,
    fill: "white",
    transform: "matrix(1 0 0 -1 461.21 223.811)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroimagev2);
export default __webpack_public_path__ + "static/media/heroimagev2.1bc2779154104606a1ebd96086065ac8.svg";
export { ForwardRef as ReactComponent };